module.exports = __webpack_public_path__ + "static/media/user-guide-6.25102a4c.png";